/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TaskDto } from '../models/task-dto';
import { TaskStatusEnum } from '../models/task-status-enum';

@Injectable({
  providedIn: 'root',
})
export class TaskService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTasks
   */
  static readonly GetTasksPath = '/tasks';

  /**
   * Get Tasks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTasks()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTasks$Response(params: {
    techStackId: string;
    status?: TaskStatusEnum;
    assigneeId?: string;
    label?: Array<string>;
  }): Observable<StrictHttpResponse<Array<TaskDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TaskService.GetTasksPath, 'get');
    if (params) {
      rb.query('techStackId', params.techStackId, {});
      rb.query('status', params.status, {});
      rb.query('assigneeId', params.assigneeId, {});
      rb.query('label', params.label, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TaskDto>>;
      })
    );
  }

  /**
   * Get Tasks.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTasks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTasks(params: {
    techStackId: string;
    status?: TaskStatusEnum;
    assigneeId?: string;
    label?: Array<string>;
  }): Observable<Array<TaskDto>> {

    return this.getTasks$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TaskDto>>) => r.body as Array<TaskDto>)
    );
  }

  /**
   * Path part for operation createTask
   */
  static readonly CreateTaskPath = '/tasks';

  /**
   * Create Task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTask()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTask$Response(params?: {
    body?: TaskDto
  }): Observable<StrictHttpResponse<TaskDto>> {

    const rb = new RequestBuilder(this.rootUrl, TaskService.CreateTaskPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TaskDto>;
      })
    );
  }

  /**
   * Create Task.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTask$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTask(params?: {
    body?: TaskDto
  }): Observable<TaskDto> {

    return this.createTask$Response(params).pipe(
      map((r: StrictHttpResponse<TaskDto>) => r.body as TaskDto)
    );
  }

  /**
   * Path part for operation getTask
   */
  static readonly GetTaskPath = '/tasks/{taskId}';

  /**
   * Get Task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTask$Response(params: {
    taskId: string;
  }): Observable<StrictHttpResponse<TaskDto>> {

    const rb = new RequestBuilder(this.rootUrl, TaskService.GetTaskPath, 'get');
    if (params) {
      rb.path('taskId', params.taskId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TaskDto>;
      })
    );
  }

  /**
   * Get Task.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTask(params: {
    taskId: string;
  }): Observable<TaskDto> {

    return this.getTask$Response(params).pipe(
      map((r: StrictHttpResponse<TaskDto>) => r.body as TaskDto)
    );
  }

  /**
   * Path part for operation updateTask
   */
  static readonly UpdateTaskPath = '/tasks/{taskId}';

  /**
   * Update Task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTask()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTask$Response(params: {
    taskId: string;
    body?: TaskDto
  }): Observable<StrictHttpResponse<TaskDto>> {

    const rb = new RequestBuilder(this.rootUrl, TaskService.UpdateTaskPath, 'put');
    if (params) {
      rb.path('taskId', params.taskId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TaskDto>;
      })
    );
  }

  /**
   * Update Task.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTask$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTask(params: {
    taskId: string;
    body?: TaskDto
  }): Observable<TaskDto> {

    return this.updateTask$Response(params).pipe(
      map((r: StrictHttpResponse<TaskDto>) => r.body as TaskDto)
    );
  }

  /**
   * Path part for operation deleteTask
   */
  static readonly DeleteTaskPath = '/tasks/{taskId}';

  /**
   * Delete Task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTask$Response(params: {
    taskId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TaskService.DeleteTaskPath, 'delete');
    if (params) {
      rb.path('taskId', params.taskId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete Task.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTask(params: {
    taskId: string;
  }): Observable<void> {

    return this.deleteTask$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
